import { IProductPrice } from './types'

export const createInitialProduct = (customerId: number) => {
  return {
    customerId,
    enabled: true,
    name: '',
    sku: '',
    productCategoryId: 0,
    countryOfOriginId: 0,
    inventoryUnitId: 0,
    physicalProperties: {
      weightMeasureUnitId: -1,
      volumeMeasureUnitId: -1,
      densityMeasureUnitId: -1,
      lengthMeasureUnitId: -1,
      isRectangular: true,
    },
    templateSettings: {
      temperatureUnitId: -1,
    },
    prices: [],
    documents: [],
  }
}

export const getActivePriceInfo = (prices?: IProductPrice[]) => {
  if (!prices || prices.length === 0) {
    return { currencyId: undefined, price: undefined }
  }

  const sortedPrices = [...prices].sort((a, b) => {
    const dateA = new Date(a.priceValidFrom || a.validFrom || '1970-01-01').getTime()
    const dateB = new Date(b.priceValidFrom || b.validFrom || '1970-01-01').getTime()
    return dateB - dateA
  })

  const currencyMap = new Map<number, IProductPrice>()
  sortedPrices.forEach((price) => {
    if (!currencyMap.has(price.currencyId)) {
      currencyMap.set(price.currencyId, price)
    }
  })

  const primaryPrice = currencyMap.values().next().value

  return {
    currencyId: primaryPrice?.currencyId,
    price: primaryPrice?.price,
  }
}
